<template>
    <div class="grid">
        <div class="grid-item grid-item-full margin-bottom-s">
            <div class="grid-fitted grid-unstackable">
                <div class="grid-item grid-item-half position-relative">
                    <organization-logo :organization="organization"/>
                </div>
                <div class="grid-item grid-item-half text-right">
                    <p class="stack-s">Credit Memo {{creditMemo.numberLabel}}</p>
                    <credit-memo-state-summary :credit-memo="creditMemo"/>
                </div>
            </div>
        </div>
        <div class="grid-item grid-item-full margin-bottom-l">
            <div class="grid">
                <organization-context v-if="firstInvoice" :invoice="firstInvoice" @organization-loaded="organization = $event.organization"/>
                <div class="grid-item grid-item-half position-relative" v-else></div>
                <div class="grid-item" v-fs-block>
                    <table class="table table-compact table-definition stack-xs table-v-alignment-top">
                        <tr>
                            <td class="no-wrap">Customer Id</td>
                            <td><router-link :to="{name: 'customer-details', params: {id: creditMemo.customerId}}">{{creditMemo.customerId}}</router-link></td>
                        </tr>
                        <tr>
                            <td>Amount</td>
                            <td>
                                {{ creditMemo.totalCredit | monetize(creditMemo.currency) }}
                                <span class="text-muted">({{ creditMemo.unusedCredit | monetize(creditMemo.currency) }} remaining)</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Reason</td>
                            <td>{{ creditMemo.reason | capitalize }}</td>
                        </tr>
                        <tr>
                            <td>Date Issued</td>
                            <td>{{creditMemo.createdTime | dateTime}}</td>
                        </tr>
                        <tr>
                            <td>Date Processed</td>
                            <td>{{creditMemo.updatedTime | dateTime}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vContact from '@/components/v-contact';
    import vInlineLoader from '@/components/v-inline-loader';
    import OrganizationContext from '@/modules/organizations/components/organization-context';
    import OrganizationLogo from '@/modules/organizations/components/organization-logo';
    import OrganizationModel from '@/common/models/organization-model';
    import ContactModel from '@/common/models/contact-model';
    import CreditMemoStateSummary from '@/modules/credit-memos/credit-memo-state-summary';
    import {mapState, mapGetters} from 'vuex';

    export default {
        components: {
            vContact,
            vInlineLoader,
            CreditMemoStateSummary,
            OrganizationContext,
            OrganizationLogo,
        },
        data() {
            return {
                organization: new OrganizationModel(),
                organizationContact: new ContactModel(),
            };
        },
        computed: {
            ...mapState('creditMemos', ['creditMemo']),
            ...mapGetters('creditMemos', ['firstInvoice']),
        },
    };
</script>
